import React from "react";
import { Link, NavLink, useNavigate } from "react-router-dom";
import { ShoppingBag, Calendar, User, Menu, X, Camera } from "lucide-react";
import { useCart, useAuth } from "../lib/store";

export default function Header() {
  const { count, setOpen } = useCart();
  const { user, logout } = useAuth();
  const [mobile, setMobile] = React.useState(false);
  const nav = useNavigate();

  const link = ({ isActive }) =>
    `text-[13px] tracking-wide font-medium transition-colors ${
      isActive ? "text-[#D4AF37]" : "text-[#0D1B2A] hover:text-[#D4AF37]"
    }`;

  return (
    <header className="header-glass sticky top-0 z-50">
      <div className="mx-auto max-w-7xl px-5 lg:px-8 h-[76px] flex items-center justify-between gap-6">
        <Link to="/" data-testid="brand-link" className="flex items-center gap-3 shrink-0">
          <div className="w-11 h-11 rounded-full bg-[#0D1B2A] flex items-center justify-center ring-2 ring-[#D4AF37]/60">
            <Camera size={20} className="text-[#D4AF37]" />
          </div>
          <div className="leading-tight">
            <div className="font-display text-[22px] text-[#0D1B2A] tracking-tight">Eterniza</div>
            <div className="font-script text-[#D4AF37] text-[18px] -mt-1.5">imãs</div>
          </div>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          <NavLink to="/" end className={link} data-testid="nav-home">Início</NavLink>
          <NavLink to="/catalogo" className={link} data-testid="nav-catalog">Catálogo</NavLink>
          <NavLink to="/agendar" className={link} data-testid="nav-schedule">Agendar</NavLink>
          <NavLink to="/sobre" className={link} data-testid="nav-about">Sobre</NavLink>
          <NavLink to="/contato" className={link} data-testid="nav-contact">Contato</NavLink>
        </nav>

        <div className="flex items-center gap-2">
          <button
            data-testid="open-cart-btn"
            onClick={() => setOpen(true)}
            className="relative w-10 h-10 rounded-full bg-white border border-[#0D1B2A]/10 flex items-center justify-center hover:border-[#D4AF37] transition-colors"
            aria-label="Abrir carrinho"
          >
            <ShoppingBag size={18} className="text-[#0D1B2A]" />
            {count > 0 && (
              <span data-testid="cart-count" className="absolute -top-1 -right-1 bg-[#D4AF37] text-[#0D1B2A] text-[10px] font-bold min-w-[18px] h-[18px] rounded-full flex items-center justify-center px-1">
                {count}
              </span>
            )}
          </button>

          {user ? (
            <div className="hidden md:flex items-center gap-2">
              <button
                data-testid="account-btn"
                onClick={() => nav(user.role === "admin" ? "/admin" : "/minha-conta")}
                className="text-[13px] font-medium text-[#0D1B2A] hover:text-[#D4AF37] px-3"
              >
                {user.role === "admin" ? "Painel" : "Olá, " + user.name.split(" ")[0]}
              </button>
              <button data-testid="logout-btn" onClick={() => { logout(); nav("/"); }} className="text-[12px] text-[#6B7280] hover:text-[#0D1B2A]">Sair</button>
            </div>
          ) : (
            <Link
              to="/entrar"
              data-testid="login-btn"
              className="hidden md:inline-flex items-center gap-2 text-[13px] font-medium text-[#0D1B2A] hover:text-[#D4AF37] px-3"
            >
              <User size={16} /> Entrar
            </Link>
          )}

          <button className="md:hidden w-10 h-10 rounded-full bg-white border border-[#0D1B2A]/10 flex items-center justify-center" onClick={() => setMobile(true)} aria-label="Menu">
            <Menu size={18} className="text-[#0D1B2A]" />
          </button>
        </div>
      </div>

      {mobile && (
        <div className="fixed inset-0 z-[60] bg-[#0D1B2A] text-white p-6 flex flex-col gap-6">
          <div className="flex items-center justify-between">
            <div className="font-display text-2xl">Menu</div>
            <button onClick={() => setMobile(false)} aria-label="Fechar"><X size={22} /></button>
          </div>
          <nav className="flex flex-col gap-4 mt-4 text-lg">
            {[
              ["/", "Início"], ["/catalogo", "Catálogo"], ["/agendar", "Agendar"],
              ["/sobre", "Sobre"], ["/contato", "Contato"], ["/entrar", user ? "Minha conta" : "Entrar"],
            ].map(([to, label]) => (
              <Link key={to} to={to} onClick={() => setMobile(false)} className="border-b border-white/10 pb-3 font-display">
                {label}
              </Link>
            ))}
          </nav>
        </div>
      )}
    </header>
  );
}
